import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const articles = [
  {
    title: "Título del artículo",
    description: "Lorem ipsum dolor sit amet. commodo. Sed a fringilla lacus.",
    image: "https://via.placeholder.com/300x200", // Reemplazar con la imagen real
  },
  {
    title: "Título del artículo",
    description: "Lorem ipsum dolor sit amet. commodo. Sed a fringilla lacus.",
    image: "https://via.placeholder.com/300x200",
  },
  {
    title: "Título del artículo",
    description: "Lorem ipsum dolor sit amet. commodo. Sed a fringilla lacus.",
    image: "https://via.placeholder.com/300x200",
  },
];

const Carousel = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: <button className="slick-prev">&#10094;</button>,
    nextArrow: <button className="slick-next">&#10095;</button>,
  };

  return (
    <div className="carousel-container">
      <h2 className="title">INFOSALUD</h2>
      <Slider {...settings}>
        {articles.map((article, index) => (
          <div key={index} className="card">
            <img src={article.image} alt={article.title} />
            <div className="card-content">
              <h3 className="card-title">{article.title}</h3>
              <p className="card-description">{article.description}</p>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Carousel;
